<template>
  <div v-if="loaded" id="expeditionsVue">
    <div v-if="expedition.deliveryOrderId != ''">
      <div>
        <img :src="logoFilename" class="imgLogo" />
      </div>

      <div id="deliveryOrderId">
        <h1>
          {{ $t("delivery.tracking") }}
        </h1>
        <h2>
          {{ expedition.deliveryOrderId }}
        </h2>
        <h3 justify="center">
          ({{ $t("reference.abbreviated") }}: {{ expedition.reference1 }})
        </h3>
      </div>
      <div id="timeLine">
        <table>
          <tr>
            <td :active="statusPreparing" :activeNext="statusTransit">
              <div class="statusContainer">
                <font-awesome-icon icon="archive" class="statusIcon" />
              </div>
              <div class="statusSpace">
                <div class="statusSpaceLine" />
              </div>
            </td>
            <td :active="statusTransit" :activeNext="statusArrived">
              <div class="statusContainer">
                <font-awesome-icon icon="road" class="statusIcon" />
              </div>
              <div class="statusSpace">
                <div class="statusSpaceLine" />
              </div>
            </td>
            <td :active="statusArrived" :activeNext="statusDelivery">
              <div class="statusContainer">
                <font-awesome-icon icon="truck-loading" class="statusIcon" />
              </div>
              <div class="statusSpace">
                <div class="statusSpaceLine" />
              </div>
            </td>
            <td :active="statusDelivery" :activeNext="statusDelivered">
              <div class="statusContainer">
                <font-awesome-icon icon="truck" class="statusIcon" />
              </div>
              <div class="statusSpace">
                <div class="statusSpaceLine" />
              </div>
            </td>
            <td :active="statusDelivered">
              <div class="statusContainer">
                <font-awesome-icon icon="thumbs-up" class="statusIcon" />
              </div>
            </td>
          </tr>
          <tr>
            <td :active="statusPreparing">
              <span>{{ $t("ORIG") }}</span>
            </td>
            <td :active="statusTransit">
              <span>{{ $t("CERR") }}</span>
            </td>
            <td :active="statusArrived">
              <span>{{ $t("PEND") }}</span>
            </td>
            <td :active="statusDelivery">
              <span>{{ $t("REPA") }}</span>
            </td>
            <td :active="statusDelivered">
              <span>{{ $t("EFEC") }}</span>
            </td>
          </tr>
        </table>
      </div>
      <div id="buttonBar" v-if="showActionsPanel">
        <div id="main">
          <div class="header">
            <font-awesome-icon icon="cubes" />
            <span>{{ $t("modifyYourDelivery") }}</span>
          </div>
          <div class="content">
            <table>
              <tr v-if="scheduleAction">
                <td>
                  <font-awesome-icon
                    icon="calendar-alt"
                    size="5x"
                    v-on:click="schelude"
                    class="actionButton"
                  />
                </td>
              </tr>
              <tr v-if="scheduleAction">
                <td>
                  <span>{{ $t("schelude") }}</span>
                </td>
              </tr>
            </table>
          </div>
        </div>
      </div>
      <div id="deliveryInfo">
        <div id="map" v-if="displayParametrization.showMap">
          <div class="header">
            <font-awesome-icon icon="map" />
            <span>{{ $t("route.map") }}</span>
          </div>
          <div class="content" v-if="this.gps.driverPosition != null">
            <HereMap
              :deliveryPosition="this.gps.deliveryPosition"
              :driverPosition="this.gps.driverPosition"
            />
          </div>
        </div>
        <div id="info">
          <div class="header">
            <font-awesome-icon icon="clock" />
            <span>{{ $t("information") }}</span>
          </div>
          <div class="content">
            <h1>{{ $t("origin") }}</h1>
            <h2>
              {{ expedition.senderName }}
            </h2>
            <h2>
              {{ expedition.senderPostalCode }} - {{ expedition.senderCity }}
            </h2>
            <hr />
            <h1>{{ $t("destination") }}</h1>
            <h2>
              {{ expedition.consigneeName }}
            </h2>
            <h2>
              {{ expedition.consigneePostalCode }} -
              {{ expedition.consigneeCity }}
            </h2>
          </div>
        </div>
      </div>
      <div id="deliveryInfoExtended">
        <div id="main">
          <div class="header">
            <font-awesome-icon icon="info" />
            <span>{{ $t("additional.information") }}</span>
          </div>
          <div class="content">
            <div class="row">
              <div class="field">
                <label class="cell">{{ $t("packages") }}</label>
                <span class="cell">{{ expedition.packageNumber }}</span>
              </div>
              <div class="field">
                <label class="cell">{{ $t("weight") }}</label>
                <span class="cell" v-if="expedition.weight != null">
                  <i18n-n :value="expedition.weight"></i18n-n>
                </span>
              </div>
            </div>
            <div class="row">
              <div class="field">
                <label class="cell">{{ $t("requested.delivery.date") }}</label>
                <span
                  class="cell"
                  v-if="expedition.requestedDeliveryDateFrom != null"
                >
                  {{
                    $d(Date.parse(expedition.requestedDeliveryDateFrom), "long")
                  }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <h1>
        {{ $t("shipment.notFound") }}
      </h1>
    </div>
  </div>
</template>

<style scope src="./css/expeditions.css"></style>

<script>
import http from "@/http-commons";
import HereMap from "@/components/HereMap.vue";
import statusjs from "@/js/statusVariables";

const CONTEXT = "/public/expeditions";

export default {
  name: "expeditions",
  components: {
    HereMap
  },
  props: {
    uuid: {
      type: String,
      required: false
    }
  },
  data: () => ({
    loaded: false,
    status: "",
    statusPreparing: false,
    statusTransit: false,
    statusArrived: false,
    statusDelivery: false,
    statusDelivered: false,
    showActions: false,
    scheduleAction: false,
    gps: {
      deliveryPosition: null,
      driverPosition: null,
      status: null
    },
    expedition: {
      organizationCode: "",
      deliveryOrderId: "",
      reference1: "",
      reference2: "",
      packageNumber: "",
      senderCode: "",
      senderTaxId: "",
      senderName: "",
      senderName2: "",
      senderAddress: "",
      senderAddress2: "",
      senderCountry: "",
      senderPostalCode: "",
      senderCity: "",
      senderTelephone: "",
      senderContactPerson: "",
      senderEmail: "",
      consigneeCode: "",
      consigneeTaxId: "",
      consigneeName: "",
      consigneeName2: "",
      consigneeAddress: "",
      consigneeAddress2: "",
      consigneeCountry: "",
      consigneePostalCode: "",
      consigneeCity: "",
      consigneeTelephone: "",
      consigneeContactPerson: "",
      consigneeEmail: "",
      serviceId: "",
      serviceName: "",
      weight: "",
      volume: "",
      refoundAmount: "",
      refoundCurrency: "",
      valueAmount: "",
      valueCurrency: "",
      incoterms: "",
      incotermsDescription: "",
      observations1: "",
      observations2: "",
      goodsDescription: "",
      palletNumber: "",
      requestedDeliveryDateFrom: "",
      requestedDeliveryDateTo: "",
      plannedDeliveryDateFrom: "",
      plannedDeliveryDateTo: "",
      companyDivision: "",
      status: ""
    },
    displayParametrization: {
      showMap: true
    }
  }),
  watch: {
    status: function(value) {
      this.statusPreparing = false;
      this.statusTransit = false;
      this.statusArrived = false;
      this.statusDelivery = false;
      this.statusDelivered = false;
      this.scheduleAction = false;
      this.showActions = false;

      if (
        value === statusjs.PENDING ||
        value === statusjs.TRANSIT ||
        value === statusjs.ARRIVED ||
        value === statusjs.DELIVERY ||
        value === statusjs.DELIVERED
      ) {
        this.statusPreparing = true;
        this.scheduleAction = false;
      }

      if (
        value === statusjs.TRANSIT ||
        value === statusjs.ARRIVED ||
        value === statusjs.DELIVERY ||
        value === statusjs.DELIVERED
      ) {
        this.statusTransit = true;
        this.scheduleAction = true;
      }

      if (
        value === statusjs.ARRIVED ||
        value === statusjs.DELIVERY ||
        value === statusjs.DELIVERED
      ) {
        this.statusArrived = true;
        this.scheduleAction = false;
      }

      if (value === statusjs.DELIVERY || value === statusjs.DELIVERED) {
        this.statusDelivery = true;
        this.scheduleAction = false;
      }

      if (value === statusjs.DELIVERED) {
        this.statusDelivered = true;
        this.scheduleAction = false;
      }

      if (this.scheduleAction) {
        this.showActions = true;
      }
    }
  },

  computed: {
    logoFilename() {
      try {
        return require(`@/assets/logo-${this.expedition.organizationCode}.svg`);
      } catch (error) {
        return "";
      }
    },
    showActionsPanel: function() {
      return this.showActions && this.expedition.scheludeToken === undefined;
    }
  },
  methods: {
    async searchExpedition(token, consigneePostalCode) {
      if (token !== null && consigneePostalCode !== null) {
        var tokenMatch;
        try {
          // Validate token MD5
          let tokenRegex = new RegExp("^\\d{0,10}[A-Z]{4}");
          tokenMatch = tokenRegex.exec(token).toString();
          var tokenMD5 = require("crypto")
            .createHash("md5")
            .update(tokenMatch.toString())
            .digest("hex");
          tokenMD5 = tokenMD5
            .substring(0, 16 - tokenMatch.length)
            .toUpperCase();
          tokenMatch = tokenMatch + tokenMD5;
        } catch (ex) {
          console.error(ex);
        }
        if (tokenMatch === token) {
          http
            .get(CONTEXT + "/" + token + "/" + consigneePostalCode)
            .then(response => {
              this.expedition = response.data;
              if (this.status == "") {
                this.status = this.expedition.status;
              }
              this.loaded = true;
            })
            .catch(e => {
              console.log(e);
            });

          http
            .get(CONTEXT + "/status/" + token + "/" + consigneePostalCode)
            .then(response => {
              //no update status if it is PEND(senda status) and status in client is CERR
              if (
                !(
                  this.status == statusjs.ARRIVED &&
                  response.data == statusjs.TRANSIT
                )
              ) {
                if (response.data.status != null) {
                  this.status = response.data.status;
                }
              }
            })
            .catch(e => {
              console.log(e);
            });

          http
            .get(CONTEXT + "/gps/" + token + "/" + consigneePostalCode)
            .then(response => {
              this.gps.driverPosition = response.data.driverPosition;
              this.gps.deliveryPosition = response.data.deliveryPosition;
              //only update status, if it is CERR or empty and Senda is PEND
              if (this.status == "" || this.status == statusjs.TRANSIT) {
                if (response.data.deliveryStatus == statusjs.ARRIVED) {
                  this.status = response.data.deliveryStatus;
                }
              }
            })
            .catch(e => {
              console.log(e);
            });
        }
      }
    },
    schelude() {
      var urlReservation =
        process.env.VUE_APP_TIME_SLOT_RESERVATION_URL +
        "?" +
        "token=" +
        this.$route.params.token +
        "&zipCode=" +
        this.$route.params.consigneePostalCode;
      if (this.$route.query.uuid != undefined) {
        urlReservation = urlReservation + "&uuid=" + this.$route.query.uuid;
      }
      window.location.href = urlReservation;
    }
  },
  beforeMount() {
    this.searchExpedition(
      this.$route.params.token,
      this.$route.params.consigneePostalCode
    );
  }
};
</script>
